export default "__VITE_ASSET__BL4XyNjM__"